
import React from 'react'
import {
  Ban,
  MessageSquare,
  Settings,
  FileText,
  Image,
  ImagePlus,
  CircleDashed,
  Hash,
  Palette,
  Cpu,
  Type,
  Video,
  Music,
  File,
  Box,
  Code,
  CheckSquare,
  Circle,
  Play,
  Sparkles,
  Table2,
  Shuffle,
} from 'lucide-react'

/**
 * HandleIcon - Static Lucide icon renderer for canvas handles
 *
 * Uses static imports (NOT dynamic) to avoid Next.js HMR issues.
 * Maps icon name strings to pre-imported Lucide components.
 */

const ICON_MAP: Record<string, React.FC<{ size?: number; strokeWidth?: number }>> = {
  'ban': Ban,
  'message-square': MessageSquare,
  'settings': Settings,
  'file-text': FileText,
  'image': Image,
  'image-plus': ImagePlus,
  'circle-dashed': CircleDashed,
  'hash': Hash,
  'palette': Palette,
  'cpu': Cpu,
  'type': Type,
  'video': Video,
  'music': Music,
  'file': File,
  'box': Box,
  'code': Code,
  'check-square': CheckSquare,
  'circle': Circle,
  'play': Play,
  'sparkles': Sparkles,
  'table': Table2,
  'shuffle': Shuffle,
}

interface HandleIconProps {
  name: string
  size?: number
}

export const HANDLE_ICON_NAMES = Object.keys(ICON_MAP)

function HandleIconComponent({ name, size = 12 }: HandleIconProps) {
  const IconComponent = ICON_MAP[name] || ICON_MAP['circle']
  return <IconComponent size={size} strokeWidth={2} />
}

export const HandleIcon = React.memo(HandleIconComponent)
HandleIcon.displayName = 'HandleIcon'
